var _path, _path2, _path3, _path4, _path5, _path6, _use, _path7, _use2, _use3, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSi = function SvgSi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 12 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ed1c24",
    d: "M0 0h12v6H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#005da4",
    d: "M0 0h12v4H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v2H0z"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    transform: "translate(2.224 1)scale(.12937)",
    viewBox: "-120 -190.223 240 309.188"
  }, props), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#005da4",
    d: "m110.26-19.478 9.74-143.75a280.22 280.22 0 0 0-240 0l9.74 143.75A155.61 155.61 0 0 0 0 118.972a155.61 155.61 0 0 0 110.26-138.45"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-90 0A138.29 138.29 0 0 0 0 100.77 138.29 138.29 0 0 0 90 0L45-60 27-36 0-90l-27 54-18-24z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "si_svg__a",
    fill: "#005da4",
    d: "M-17.196-2.196A6 6 0 0 0-9 0a6 6 0 0 1 6 0 6 6 0 0 0 6 0 6 6 0 0 1 6 0 6 6 0 0 0 8.196-2.196v1.732A6 6 0 0 1 9 1.732a6 6 0 0 0-6 0 6 6 0 0 1-6 0 6 6 0 0 0-6 0 6 6 0 0 1-8.196-2.196z",
    transform: "matrix(5 0 0 5 0 25.981)"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#si_svg__a",
    transform: "translate(0 17.321)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "si_svg__b",
    fill: "#fd0",
    strokeWidth: 0.2,
    d: "m0-5 1 3.268L4.33-2.5 2 0l2.33 2.5L1 1.732 0 5l-1-3.268-3.33.768L-2 0l-2.33-2.5 3.33.768z",
    transform: "translate(0 -120)scale(2.25)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#si_svg__b",
    transform: "translate(-33.75 -45)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#si_svg__b",
    transform: "translate(33.75 -45)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed1c24",
    d: "m-111.58-167.05 9.96 146.99A146.95 146.95 0 0 0 0 109.89 146.95 146.95 0 0 0 101.62-20.06l9.96-146.99a280 280 0 0 0 8.42 3.82l-9.74 143.75A155.61 155.61 0 0 1 0 118.97 155.61 155.61 0 0 1-110.26-19.48L-120-163.23a280 280 0 0 0 8.42-3.82"
  }))));
};
export default SvgSi;